import React from 'react'
import { makeStyles, tokens } from '@fluentui/react-components'
import { Activity } from '../../api/schemas/schema'
import { ReadOnlyModal } from '../common/modal/ReadOnlyModal'
import { Title } from '../common/text/Title'
import { CommentThread } from './CommentThread'
import { formatDate } from '../../helpers/stringHelper'
import { getFullName } from '../../helpers/accountHelper'
import { t } from '../../i18n/i18n'

// Same grey the calendar wheel falls back to when an activity has no colour of its own.
const FALLBACK_COLOR = '#74808F'

const useStyles = makeStyles({
   titleRow: {
      display: 'flex',
      alignItems: 'center',
      gap: tokens.spacingHorizontalS,
   },
   colorDot: {
      width: '10px',
      height: '10px',
      minWidth: '10px',
      borderRadius: '50%',
   },
})

type ModalActivityViewProps = {
   activity?: Activity
   onClose: () => void
}

// Read-only counterpart to ModalActivity. The overview only shows activities - editing and
// deleting stay on the annual calendar page.
export const ModalActivityView = ({ activity, onClose }: ModalActivityViewProps) => {
   const classes = useStyles()
   if (!activity) return null

   const title = (
      <div className={classes.titleRow}>
         <span className={classes.colorDot} style={{ backgroundColor: activity.colorHex || FALLBACK_COLOR }} />
         <Title as="h3" noMargin>
            {activity.title}
         </Title>
      </div>
   )

   const fields = [
      { label: t('Description'), value: activity.description },
      { label: t('StartDate'), value: activity.startDate ? formatDate(activity.startDate) : undefined },
      { label: t('EndDate'), value: activity.endDate ? formatDate(activity.endDate) : undefined },
      { label: t('Responsible'), value: activity.responsible ? getFullName(activity.responsible) : undefined },
   ]

   return (
      <ReadOnlyModal open={!!activity} title={title} fields={fields} onClose={onClose}>
         {activity.id && <CommentThread activityId={activity.id} readOnly />}
      </ReadOnlyModal>
   )
}
